import { render, staticRenderFns } from "./ScriptPreviewModal.vue?vue&type=template&id=1bf85c8c&scoped=true"
import script from "./ScriptPreviewModal.vue?vue&type=script&lang=js"
export * from "./ScriptPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ScriptPreviewModal.vue?vue&type=style&index=0&id=1bf85c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf85c8c",
  null
  
)

export default component.exports